const updates = [
  { time: '10分钟前', title: '某选秀冠军被曝学历造假，母校回应称正在核查', tag: '新' },
  { time: '1小时前', title: '知名导演新片片场发生安全事故，一名工作人员受伤送医', tag: '' },
  { time: '3小时前', title: '带货一哥李某某涉嫌虚假宣传被市场监管局立案调查', tag: '热' },
  { time: '6小时前', title: '某女团成员社交账号突然清空，疑与经纪公司解约有关', tag: '' },
  { time: '9小时前', title: '影视城群演集体罢工要求涨薪，多部在拍剧集被迫停工', tag: '新' },
  { time: '12小时前', title: '当红小生前女友发文暗指被PUA，评论区瞬间沦陷', tag: '' },
  { time: '18小时前', title: '某综艺节目录制现场发生争执，两位嘉宾当场翻脸离场', tag: '' },
  { time: '1天前', title: '多平台联合发布网络主播黑名单，涉及偷逃税款等违规行为', tag: '热' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[850px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          最新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时追踪全网黑料动态，第一时间推送猛料
        </p>
        <div className="relative pl-8 before:absolute before:left-[11px] before:top-2 before:bottom-2 before:w-px before:bg-secondary-300">
          {updates.map((u, i) => (
            <div key={i} className="relative pb-6 last:pb-0">
              <span className="absolute -left-[27px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 flex-shrink-0"></span>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1.5 sm:gap-3">
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{u.time}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {u.title}
                    {u.tag && (
                      <span className={`inline-flex ml-2 px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                        u.tag === '热' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                      }`}>
                        {u.tag}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}